import { myAnonymity } from "@forproxyband/react-tools";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const getAnonymityInfo = createAsyncThunk(
  "client/getAnonymityInfo",
  async (_, { rejectWithValue }) => {
    try {
      return await myAnonymity.info();
    } catch (e) {
      return rejectWithValue(e.response.data.error);
    }
  },
);
